import { type Console } from '@/entities/console';
import request from '@/shared/api/request';

export const openStackletConsole = (
  id: number,
): Promise<{
  console: Console;
}> =>
  request({
    url: `/stacklets/${id}/console/`,
  });
